import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';

import {
    combineReducers,
    createStore
} from 'redux';

import {Provider} from 'react-redux';
import { reducer as leadFormReducer } from 'redux-form';


import './index.css';
import App from './App';


const userXReducers = combineReducers({
    form: leadFormReducer,
    userXInit: (state={}, action) => state
});

const userXStore = createStore( userXReducers );

ReactDOM.render(
    <Provider store={userXStore}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
    , document.getElementById('user-x-root')
);




// WEBPACK FOOTER //
// ./src/index.js